import { useEffect, useRef } from "react";

export default function useOnce(callback: () => void) {
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;
    callback();
  }, [callback]);
}